import {Injectable} from '@angular/core';
import {ConnectorService} from './connector.service';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class QueueService extends ConnectorService {
    fileOperations(): Observable<{ events: any[] }> {
        return this.get('instance/events');
    }
}
